
import {of as observableOf,  Observable, Subscription } from 'rxjs';
import { AfterViewInit, Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, NgForm, Validators } from '@angular/forms';
import { ImpersonateService } from './impersonate.service';
import * as _ from 'lodash';
import { add } from 'ngx-bootstrap/chronos';
import { ImpersonateModel } from './impersonate.model';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { B2CAdminComponent } from '../../b2c-admin.component';
import { ClinicsService } from '../../../../clinics/clinics.service';
import { PasswordService } from '../../../../auth/forgot-password/password.service';
import { AuthService } from '../../../../core/auth.service';
import { CoreService } from '../../../../core/core.service';
import { BaseService } from '../../../../shared/base.service';
import { AppService } from '../../../../app.service';
import { UsersService } from '../../../../users/users.service';
import { HomeService } from '../../../home.service';
import { MaintenanceService } from '../../../../maintenance/maintenance.service';
import { SecureApi } from '../../../../core/secure.api';
import { MaintenanceComponent } from '../../../../maintenance/maintenance.component';

@Component({
    selector: 'impersonate-component',
    templateUrl: './impersonate.component.html',
    styleUrls: ['./impersonate.component.scss'],
    providers: [ImpersonateService, ClinicsService, PasswordService ,BaseService]
})

export class ImpersonateComponent extends B2CAdminComponent implements OnInit {
    helpClinicProfile: any;
    @Input() isHome = false;
    @Input() filters;
    @Input() url = '/admin/impersonate';
    roles: Object[] = [];
    clinics: Object[] = [];
    articleTypes: Object[] = [];

    // define what table columns to display [column key, label, css class]
    readonly tableColumns = [
        ['id', 'Patient Id', 'col-xs-2'],
        ['name', 'Patient Name', 'col-xs-4'],
        ['email', 'Email', 'col-xs-4'],
    ];

    constructor(public authService: AuthService,
                public coreService: CoreService,
                public translate: TranslateService,
                public router: Router,
                public fb: FormBuilder,
                public baseService: BaseService,
                public appService: AppService,
                public usersService: UsersService,
                public homeService: HomeService,
                public clinicService: ClinicsService,
                public maintenanceService: MaintenanceService,
                public secureApi: SecureApi,
                public maintenanceComponent: MaintenanceComponent,
                public route: ActivatedRoute,
                public impersonateService: ImpersonateService) {
        super(authService, coreService, router, translate,fb,  baseService, appService, usersService, homeService, clinicService , maintenanceService, secureApi, maintenanceComponent );
    }

    ngOnInit() {
        this.searchInfo = new ImpersonateModel();
        this.sortedColumn = 'code';
        this.url = 'b2c-patients/impersonate';
        this.token = this.authService.user['token'];

        this.initSorting();

        // Remove filter start - end date
        delete this.filterParams.startDate;
        delete this.filterParams.endDate;

        // process url query parameters e.g.
        this.route.queryParams.subscribe(params => {
            this.initFilter(this.isHome, params);
        });

    }

    /**
     * @param {SimpleChanges} changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes['filters'] && this.filters) {
            return this.getItems();
        }
    }

    getItems() {
        this.initPageSize(this.isHome);
        this.impersonateService.getAll(this.filters)
            .subscribe(data => {
                this.isLoading = false;
                this.setData(data);
            });
    }

    setData(data: any): void {
        this.items = data['items'] || [];
        this.paginationHidden = this.items.length === 0;
        if (data.filters != null) {
            this.filters = data.filters;
            this.asyncFilters = observableOf(data.filters);
        }
    }

    navigateRoute() {
        this.router.navigate(['./'], {
            relativeTo: this.route
        });
    }

    sortImpersonate(column) {
        if (column === 'created_at') {
            column = 'created_at_sort';
        }

        this.sort(column, false, this.sortUsingApi);
    }
}
